module.exports = __webpack_public_path__ + "img/9e1a7b4.png";